import roleCible from '../../assets/role-cible.png';
import roleConnector from '../../assets/role-connector.png';
import roleDesigner from '../../assets/role-designer.png';
import roleFolowup from '../../assets/role-folowup.png';
import roleLook from '../../assets/role-look.png';
import roleStat from '../../assets/role-stat.png';
import roleData from '../../assets/role-data.png';

const imagePaths = [
  roleCible,
  roleConnector,
  roleDesigner,
  roleFolowup,
  roleLook,
  roleStat,
  roleData
];

const imageNames = [
  'roleCible',
  'roleConnector',
  'roleDesigner',
  'roleFolowup',
  'roleLook',
  'roleStat',
  'roleData'
];

const imageChoices = imagePaths.map((path, index) => ({
  value: imageNames[index],
  text: <img src={path} alt={`Image ${index + 1}`}  /> 
}));

// imageChoices.push({
//   value: 'importFile',
//   text: 'Import my logo',
// });

export default imageChoices;
